import { useMemo } from 'react';
import { usePerpMarketsLookup } from 'src/hooks/perpMarkets/usePerpMarketsLookup';

export const usePerpMarketsOnlyTabs = ({
	withBaseAssetSymbol = false,
}: {
	withBaseAssetSymbol?: boolean;
} = {}) => {
	const perpMarketsLookup = usePerpMarketsLookup();

	return useMemo(() => {
		return [{ label: 'All', value: 'all_markets' }].concat(
			perpMarketsLookup.map((market) => ({
				label: withBaseAssetSymbol ? market.baseAssetSymbol : market.symbol,
				value: market.symbol,
			}))
		);
	}, [perpMarketsLookup]);
};
